import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import CustomSelect from "../../Components/CustomSelect";
import { toast } from "react-toastify";
import Tooltip from "@mui/material/Tooltip";
import ImageUploadField from "./ImageUploadField";
import EmptyState from "../../Components/EmptyState";

const getFileNameFromUrl = (url) => {
  if (!url) return "";
  try {
    const cleanUrl = url.split("?")[0].split("#")[0];
    return cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
  } catch (e) {
    return "";
  }
};

export default function Games() {
  const { accessObject } = useAppContext();
  const [showPage, setShowPage] = React.useState(false);
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [platformTab, setPlatformTab] = React.useState("android");

  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [imageFile, setImageFile] = React.useState([]);
  const [versionImageFile, setVersionImageFile] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const LoginSchema = Yup.object().shape({
    gameNo: Yup.string().required("Game Name is required"),
    bundleName: Yup.string().required("Bundle Name is required"),
    sceneName: Yup.string().required("Scene Name is required"),
    driveLink1: Yup.string().required("Drive Link 1 is required"),
    driveLink2: Yup.string().required("Drive Link 2 is required"),
    driveLink3: Yup.string().required("Drive Link 3 is required"),
    platformType: Yup.string().required("Platform Type is required"),
    tag: Yup.string().required("Tag is required"),
    category: Yup.string().required("Category is required"),
    uploadImg: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required("Image name is required"),
        width: Yup.number().required("Width is required"),
        height: Yup.number().required("Height is required"),
      })
    ),
    version_data: Yup.array().of(
      Yup.object().shape({
        version: Yup.string().required("Version is required"),
        isUpdate: Yup.string().required("isUpdate flag is required"),
      })
    ),
  });

  React.useEffect(() => {
    getBranch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platformTab]);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/games/get-games?platform_type=${platformTab}`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        console.log("dataTable.dataRows :::", response.data.data);
        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const clickEditButton = (item) => {
    console.log("item::: ", item);
    setShowPage(true);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
    setImageFile([]);
    setVersionImageFile([]);
  };

  const updateTournament = async (value) => {
    console.log("updateTournament value :::", value);
    setbuttonLoader(true);

    const hasEmptyImage = value.uploadImg.some(
      (item) => !item.image || item.image.trim() === ""
    );

    if (hasEmptyImage) {
      toast.error("Upload Images required");
      return;
    }

    try {
      const formData = new FormData();

      formData.append("bundleName", value.bundleName);
      formData.append("category", value.category);
      formData.append("driveLink1", value.driveLink1);
      formData.append("driveLink2", value.driveLink2);
      formData.append("driveLink3", value.driveLink3);
      formData.append("gameNo", value.gameNo);
      formData.append("platformType", value.platformType);
      formData.append("sceneName", value.sceneName);
      formData.append("tag", value.tag);
      if (value.version_data && Array.isArray(value.version_data)) {
        const versionData = value.version_data || [];
        const rowData = rowValue.version_data || [];
        // ----- 1. Remove entries that exist in rowData but not in versionData -----
        const rowMap = new Map(rowData.map((item) => [item._id, item]));
        const versionRemoveIds = rowData
          .filter(
            (rowItem) => !versionData.find((vd) => vd._id === rowItem._id)
          )
          .map((rowItem) => rowItem._id);
        if (versionRemoveIds.length > 0) {
          formData.append(
            "version_data_remove",
            JSON.stringify(versionRemoveIds)
          );
        }
        // ----- 2. Update existing entries and attach base64 image if present -----
        const versionDataUpdate = [];
        versionData.forEach((vd, index) => {
          if (vd._id && rowMap.has(vd._id)) {
            const { _id, version, isUpdate, image } = vd;
            versionDataUpdate.push({
              _id,
              version,
              isUpdate: isUpdate === "true" || isUpdate === true,
            });
            if (image && image.startsWith("data:")) {
              const byteString = atob(image.split(",")[1]);
              const mimeString = image
                .split(",")[0]
                .split(":")[1]
                .split(";")[0];
              const ab = new ArrayBuffer(byteString.length);
              const ia = new Uint8Array(ab);
              for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
              }
              const file = new File([ab], vd.fileName || `version_file_update_${index}.jpg`, {
                type: mimeString,
              });
              formData.append(`version_file_update_${index}`, file);
            }
          }
        });
        if (versionDataUpdate.length > 0) {
          formData.append(
            "version_data_update",
            JSON.stringify(versionDataUpdate, null, 2)
          );
        }
        // ----- 3. Add new entries (without _id) and attach base64 image if present -----
        const versionDataAdd = [];
        let addIndex = 0; // Tracks the index in versionDataAdd only

        versionData.forEach((vd) => {
          if (!vd._id) {
            const { version, isUpdate, image } = vd;

            // Add entry to version_data_add
            versionDataAdd.push({
              version,
              isUpdate: isUpdate === "true" || isUpdate === true,
            });

            // If there's a base64 image, convert and append it using addIndex
            if (image && image.startsWith("data:")) {
              const base64Parts = image.split(",");
              const byteString = atob(base64Parts[1]);
              const mimeString = base64Parts[0].split(":")[1].split(";")[0];

              const ab = new ArrayBuffer(byteString.length);
              const ia = new Uint8Array(ab);
              for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
              }

              const file = new File([ab], vd.fileName || `version_file_${addIndex}.jpg`, {
                type: mimeString,
              });

              console.log("addIndex::: ", addIndex);
              formData.append(`version_file_${addIndex}`, file);
            }

            // Increment addIndex after each push to versionDataAdd
            addIndex++;
          }
        });

        // Final append
        if (versionDataAdd.length > 0) {
          formData.append(
            "version_data_add",
            JSON.stringify(versionDataAdd, null, 2)
          );
        }
      }

      if (value.uploadImg && Array.isArray(value.uploadImg)) {
        const uploadData = value.uploadImg || [];
        const rowData = rowValue.uploadImg || [];
        // ----- 1. Remove entries that exist in rowData but not in versionData -----
        const rowMap = new Map(rowData.map((item) => [item._id, item]));
        const removeUploadImgIds = rowData
          .filter((rowItem) => !uploadData.find((vd) => vd._id === rowItem._id))
          .map((rowItem) => rowItem._id);

        if (removeUploadImgIds.length > 0) {
          formData.append(
            "uploadImg_remove",
            JSON.stringify(removeUploadImgIds)
          );
        }
        // ----- 2. Update existing entries and attach base64 image if present -----
        const uploadDataUpdate = [];
        uploadData.forEach((vd, index) => {
          if (vd._id && rowMap.has(vd._id)) {
            const { _id, name, width, height, image } = vd;
            uploadDataUpdate.push({ _id, name, width, height });
            if (image && image.startsWith("data:")) {
              const byteString = atob(image.split(",")[1]);
              const mimeString = image
                .split(",")[0]
                .split(":")[1]
                .split(";")[0];
              const ab = new ArrayBuffer(byteString.length);
              const ia = new Uint8Array(ab);
              for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
              }
              const file = new File([ab], vd.fileName || `uploadImg_update_${index}.jpg`, {
                type: mimeString,
              });
              formData.append(`uploadImg_update_${index}`, file);
            }
          }
        });
        if (uploadDataUpdate.length > 0) {
          formData.append(
            "uploadImg_update",
            JSON.stringify(uploadDataUpdate, null, 2)
          );
        }

        // ----- 3. Add new entries (without _id) and attach base64 image if present -----
        const uploadDataAdd = [];
        let addIndex = 0; // Tracks the index in uploadDataAdd only

        uploadData.forEach((vd) => {
          if (!vd._id) {
            const { name, width, height, image } = vd;

            // Add entry to version_data_add
            uploadDataAdd.push({
              name,
              width,
              height,
            });

            // If there's a base64 image, convert and append it using addIndex
            if (image && image.startsWith("data:")) {
              const base64Parts = image.split(",");
              const byteString = atob(base64Parts[1]);
              const mimeString = base64Parts[0].split(":")[1].split(";")[0];

              const ab = new ArrayBuffer(byteString.length);
              const ia = new Uint8Array(ab);
              for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
              }

              const file = new File([ab], vd.fileName || `uploadImg_${addIndex}.jpg`, {
                type: mimeString,
              });

              formData.append(`uploadImg_${addIndex}`, file);
            }

            // Increment addIndex after each push to uploadDataAdd
            addIndex++;
          }
        });

        // Final append
        if (uploadDataAdd.length > 0) {
          formData.append(
            "uploadImg_add",
            JSON.stringify(uploadDataAdd, null, 2)
          );
        }
      }

      axios(`${API_URL}/api/admin/games/update-games/${rowValue._id}`, {
        method: "PATCH",
        data: formData,
        credentials: "include",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((result) => {
          console.log("updateTournament update :::", result.data);

          if (result.data.status) {
            setbuttonLoader(false);
            successAdd(result.data.message);
          } else {
            warningAlert();
            setbuttonLoader(false);
          }
        })
        .catch((err) => {
          setbuttonLoader(false);
          console.log("updateTournament err :::", err);
          warningAlert();
          setbuttonLoader(false);
        });
    } catch (error) {
      console.log("error::: ", error);
      setbuttonLoader(false);
    }
  };

  const addNewTournament = async (value) => {
    setbuttonLoader(true);
    const hasEmptyImage = value.uploadImg.some(
      (item) => !item.image || item.image.trim() === ""
    );

    if (hasEmptyImage) {
      toast.error("Upload Images required");
      return;
    }

    const formData = new FormData();

    // Append basic fields
    formData.append("bundleName", value.bundleName);
    formData.append("category", value.category);
    formData.append("driveLink1", value.driveLink1);
    formData.append("driveLink2", value.driveLink2);
    formData.append("driveLink3", value.driveLink3);
    formData.append("gameNo", value.gameNo);
    formData.append("platformType", value.platformType);
    formData.append("sceneName", value.sceneName);
    formData.append("tag", value.tag);
    if (value.version_data && Array.isArray(value.version_data)) {
      for (let index = 0; index < value.version_data.length; index++) {
        const img = value.version_data[index];
        let file;
        if (img.image && img.image.startsWith("data:")) {
          const byteString = atob(img.image.split(",")[1]);
          const mimeString = img.image
            .split(",")[0]
            .split(":")[1]
            .split(";")[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([ab], { type: mimeString });
          file = new File([blob], img.fileName || `version_file_${index}.jpg`, { type: mimeString });
        }
        if (file) {
          formData.append(`version_file_${index}`, file);
        }
      }

      // Remove image and fileName fields from metadata
      const uploadImgMetadata = value.version_data.map(
        ({ image, fileName, ...rest }) => rest
      );
      formData.append("version_data", JSON.stringify(uploadImgMetadata));
    }

    if (value.uploadImg && Array.isArray(value.uploadImg)) {
      value.uploadImg.forEach((img, index) => {
        if (img.image && img.image.startsWith("data:")) {
          const byteString = atob(img.image.split(",")[1]);
          const mimeString = img.image
            .split(",")[0]
            .split(":")[1]
            .split(";")[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([ab], { type: mimeString });
          const file = new File([blob], img.fileName || `uploadImg_${index}.jpg`, {
            type: mimeString,
          });
          formData.append(`uploadImg_${index}`, file);
        }
      });

      // Remove image and fileName fields from metadata
      const uploadImgMetadata = value.uploadImg.map(
        ({ image, fileName, ...rest }) => rest
      );
      formData.append("uploadImg", JSON.stringify(uploadImgMetadata));
    }

    axios(`${API_URL}/api/admin/games/add-games`, {
      method: "POST",
      data: formData,
      credentials: "include",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((result) => {
        console.log("games/add-games result...", result);

        if (result.data.status) {
          setbuttonLoader(false);
          successAdd(result.data.message);

          // const formData = new FormData();
          // imageFile.forEach((imageFileData) => {
          //   formData.append("games-image", imageFileData);
          // });
          // axios
          //   .post(
          //     `${API_URL}/api/admin/games/upload-games/${result.data.data._id}`,
          //     formData,
          //     {
          //       headers: {
          //         "Content-Type": "multipart/form-data",
          //       },
          //     }
          //   )
          //   .then((result) => {
          //     console.log("result...", result);
          //     if (result.data.status) {
          //       setbuttonLoader(false);
          //       // socket.emit("bannerAdd");
          //       successAdd(result.data.message);
          //     } else {
          //       toast.error(result.data.message);
          //       setbuttonLoader(false);
          //     }
          //   })
          //   .catch((err) => {
          //     console.log("handleSubmit err :::", err);
          //   });
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
        warningAlert();
        setbuttonLoader(false);
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        btnSize="md"
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
        title=""
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this game record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        title="Success"
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert"
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The game record has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    axios
      .delete(`${API_URL}/api/admin/games/delete-games/${e._id}`)
      .then((res) => {
        successDeleted();
      });
  };

  const successAdd = () => {
    console.log("done");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Added successfully!"
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      >
        Your Games Record has been Added...
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    console.log("donw");
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block" }}
        title="Something Went Wrong .....!"
        onConfirm={() => {
          setAlert(null);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  const tooltipProps = {
    tooltip: {
      sx: {
        bgcolor: '#2d3748',
        color: '#fff',
        fontSize: '13px',
        padding: '8px 12px',
        boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
        borderRadius: '6px'
      }
    },
    arrow: {
      sx: {
        color: '#2d3748'
      }
    }
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  gameNo: rowValue ? rowValue.gameNo : "",
                  bundleName: rowValue ? rowValue.bundleName : "",
                  sceneName: rowValue ? rowValue.sceneName : "",
                  driveLink1: rowValue ? rowValue.driveLink1 : "",
                  driveLink2: rowValue ? rowValue.driveLink2 : "",
                  driveLink3: rowValue ? rowValue.driveLink3 : "",
                  platformType: rowValue ? rowValue.platformType : (platformTab === "android" ? 0 : 1),
                  tag: rowValue ? rowValue?.tag : 0,
                  category: rowValue ? rowValue?.category : 0,
                  uploadImg:
                    rowValue &&
                      rowValue.uploadImg &&
                      rowValue.uploadImg.length > 0
                      ? rowValue.uploadImg.map((item) => ({
                        name: item.name || "",
                        width: item.width || 0,
                        height: item.height || 0,
                        image: item.image_url || "",
                        fileName: getFileNameFromUrl(item.image_url),
                        _id: item._id || "",
                      }))
                      : [],
                  version_data:
                    rowValue &&
                      rowValue.version_data &&
                      rowValue.version_data.length > 0
                      ? rowValue.version_data.map((item) => ({
                        isUpdate: item.isUpdate ? "true" : "false" || "",
                        image: item.fileUrl || "",
                        fileName: getFileNameFromUrl(item.fileUrl),
                        version: item.version || "",
                        _id: item._id || "",
                      }))
                      : [
                        {
                          version: "",
                          isUpdate: "",
                          image: "",
                          fileName: "",
                        },
                      ],
                }}
                validationSchema={LoginSchema}
                onSubmit={async (values) => {
                  // setbuttonLoader(true);

                  if (openValue === 1) {
                    console.log("update formik value :::", openValue);
                    await addNewTournament(values);
                  }
                  if (openValue === 2) {
                    console.log("update formik value :::", openValue);
                    await updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, values, setFieldValue }) => (
                  <Form>
                    <div className="row">
                      {/* Game Name & Bundle Name */}
                      <div className="col-md-6">
                        <CustomSelect
                          label="Game Name"
                          name="gameNo"
                          options={[
                            { value: "", label: "Select Game" },
                            { value: 3, label: "Block Blast" },
                            { value: 7, label: "Candy Cream" },
                            { value: 9, label: "Chess Gamebit" },
                            { value: 10, label: "Ludo Lion" },
                          ]}
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Bundle Name <span className="text-danger">*</span>{" "}
                            <Tooltip title="Unity AssetBundle name configured inside the Unity project." placement="top" arrow enterTouchDelay={0} componentsProps={tooltipProps}>
                              <i className="fas fa-info-circle text-info" style={{ cursor: "pointer", marginLeft: "5px" }}></i>
                            </Tooltip>
                          </label>
                          <Field
                            type="text"
                            name="bundleName"
                            placeholder="com.wolfwin.game"
                            className={`mt-1 form-control ${touched.bundleName && errors.bundleName ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="bundleName" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* Scene Name & Drive Link 1 */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Scene Name <span className="text-danger">*</span>{" "}
                            <Tooltip title="Used for scene loading in Unity. Must match the exact scene name added in Unity Build Settings. Example: Ludo, MainMenu, BattleScene" placement="top" arrow enterTouchDelay={0} componentsProps={tooltipProps}>
                              <i className="fas fa-info-circle text-info" style={{ cursor: "pointer", marginLeft: "5px" }}></i>
                            </Tooltip>
                          </label>
                          <Field
                            type="text"
                            name="sceneName"
                            placeholder="Enter scene name"
                            className={`mt-1 form-control ${touched.sceneName && errors.sceneName ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="sceneName" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Primary Drive Link <span className="text-danger">*</span>{" "}
                            <Tooltip title="Main external download source used when files are not hosted on our server." placement="top" arrow enterTouchDelay={0} componentsProps={tooltipProps}>
                              <i className="fas fa-info-circle text-info" style={{ cursor: "pointer", marginLeft: "5px" }}></i>
                            </Tooltip>
                          </label>
                          <Field
                            type="text"
                            name="driveLink1"
                            placeholder="Drive Link 1"
                            className={`mt-1 form-control ${touched.driveLink1 && errors.driveLink1 ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="driveLink1" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* Drive Link 2 & 3 */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Secondary Drive Link <span className="text-danger">*</span>{" "}
                            <Tooltip title="Backup external download source used if the primary link fails." placement="top" arrow enterTouchDelay={0} componentsProps={tooltipProps}>
                              <i className="fas fa-info-circle text-info" style={{ cursor: "pointer", marginLeft: "5px" }}></i>
                            </Tooltip>
                          </label>
                          <Field
                            type="text"
                            name="driveLink2"
                            placeholder="Drive Link 2"
                            className={`mt-1 form-control ${touched.driveLink2 && errors.driveLink2 ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="driveLink2" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Fallback Drive Link <span className="text-danger">*</span>{" "}
                            <Tooltip title="Final fallback download source used if all other links are unavailable." placement="top" arrow enterTouchDelay={0} componentsProps={tooltipProps}>
                              <i className="fas fa-info-circle text-info" style={{ cursor: "pointer", marginLeft: "5px" }}></i>
                            </Tooltip>
                          </label>
                          <Field
                            type="text"
                            name="driveLink3"
                            placeholder="Drive Link 3"
                            className={`mt-1 form-control ${touched.driveLink3 && errors.driveLink3 ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="driveLink3" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row mb-3">
                      {/* Platform & Increments */}
                      <div className="col-md-6">
                        <CustomSelect
                          label="Platform Type"
                          name="platformType"
                          options={[
                            { value: "", label: "Select Platform" },
                            { value: 0, label: "Android" },
                            { value: 1, label: "iOS" },
                            { value: 2, label: "Web" },
                          ]}
                        />
                      </div>
                    </div>

                    <div className="row">
                      {/* Tag & Category */}
                      <div className="col-md-6">
                        <CustomSelect
                          label="Game Tag"
                          name="tag"
                          options={[
                            { value: 0, label: "New" },
                            { value: 1, label: "Popular" },
                          ]}
                        />
                      </div>
                      <div className="col-md-6">
                        <CustomSelect
                          label="Category"
                          name="category"
                          options={[
                            { value: 0, label: "Casual" },
                            { value: 1, label: "Strategy" },
                            { value: 2, label: "Action" },
                          ]}
                        />
                      </div>
                    </div>

                    <div className="mt-4 mb-3 d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">Game Banners</h5>
                      <FieldArray
                        name="uploadImg"
                        render={(arrayHelpers) => (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm mb-3"
                            onClick={() =>
                              arrayHelpers.unshift({
                                name: "",
                                width: "",
                                height: "",
                                image: "",
                              })
                            }
                          >
                            <AddIcon fontSize="small" className="mr-1" />
                            Add New Banner
                          </button>
                        )}
                      />
                    </div>

                    <FieldArray
                      name="uploadImg"
                      render={(arrayHelpers) => (
                        <div>
                          {values.uploadImg.map((item, index) => (
                            <div key={index} className="card mb-3" style={{ borderRadius: '10px' }}>
                              <div className="card-body p-3">
                                <div className="row align-items-end">
                                  <div className="col-md-1 text-center pb-2">
                                    <span className="badge badge-secondary">{values.uploadImg.length - index}</span>
                                  </div>
                                  <div className="col-md-3">
                                    <label className="small text-muted font-weight-bold mb-1">Banner Name</label>
                                    <Field
                                      type="text"
                                      name={`uploadImg[${index}].name`}
                                      placeholder="e.g. Home Banner"
                                      className={`form-control ${touched.uploadImg?.[index]?.name &&
                                          errors.uploadImg?.[index]?.name
                                          ? "is-invalid"
                                          : ""
                                        }`}
                                    />
                                    <ErrorMessage
                                      component="div"
                                      name={`uploadImg[${index}].name`}
                                      className="invalid-feedback"
                                    />
                                  </div>

                                  <div className="col-md-2">
                                    <label className="small text-muted font-weight-bold mb-1">Dim. (W x H)</label>
                                    <div className="d-flex">
                                      <Field
                                        type="number"
                                        name={`uploadImg[${index}].width`}
                                        placeholder="W"
                                        className={`form-control mr-1 ${touched.uploadImg?.[index]?.width &&
                                            errors.uploadImg?.[index]?.width
                                            ? "is-invalid"
                                            : ""
                                          }`}
                                      />
                                      <Field
                                        type="number"
                                        name={`uploadImg[${index}].height`}
                                        placeholder="H"
                                        className={`form-control ${touched.uploadImg?.[index]?.height &&
                                            errors.uploadImg?.[index]?.height
                                            ? "is-invalid"
                                            : ""
                                          }`}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <label className="small text-muted font-weight-bold mb-1">Banner Image</label>
                                    <ImageUploadField
                                      name="uploadImg"
                                      index={index}
                                      item={item}
                                      setFieldValue={setFieldValue}
                                      imageFile={imageFile}
                                    />
                                  </div>

                                  <div className="col-md-2 text-right">
                                    <button
                                      className="btn btn-outline-danger btn-sm"
                                      type="button"
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      <ClearIcon fontSize="small" /> Remove
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    />

                    <div className="mt-4 mb-3 d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">Game Versions</h5>
                      <FieldArray
                        name="version_data"
                        render={(arrayHelpers) => (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm mb-3"
                            onClick={() =>
                              arrayHelpers.unshift({
                                version: "",
                                isUpdate: false,
                                image: "",
                              })
                            }
                          >
                            <AddIcon fontSize="small" className="mr-1" />
                            Add New Version
                          </button>
                        )}
                      />
                    </div>

                    <FieldArray
                      name="version_data"
                      render={(arrayHelpers) => (
                        <div>
                          {values.version_data.map((item, index) => (
                            <div key={index} className="card mb-3" style={{ borderRadius: '10px' }}>
                              <div className="card-body p-3">
                                <div className="row align-items-end">
                                  <div className="col-md-1 text-center pb-2">
                                    <span className="badge badge-secondary">{values.version_data.length - index}</span>
                                  </div>
                                  <div className="col-md-3">
                                    <label className="small text-muted font-weight-bold mb-1">Version Number</label>
                                    <Field
                                      type="text"
                                      name={`version_data[${index}].version`}
                                      placeholder="e.g. 1.8.0"
                                      className={`form-control ${touched.version_data?.[index]?.version &&
                                          errors.version_data?.[index]?.version
                                          ? "is-invalid"
                                          : ""
                                        }`}
                                    />
                                    <ErrorMessage
                                      component="div"
                                      name={`version_data[${index}].version`}
                                      className="invalid-feedback"
                                    />
                                  </div>

                                  <div className="col-md-2">
                                    <label className="small text-muted font-weight-bold mb-1">Force Update?</label>
                                    <div className="custom-control custom-switch pt-2">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id={`isUpdate-${index}`}
                                        checked={values.version_data[index].isUpdate === "true" || values.version_data[index].isUpdate === true}
                                        onChange={(e) => setFieldValue(`version_data[${index}].isUpdate`, e.target.checked)}
                                      />
                                      <label className="custom-control-label font-weight-normal" htmlFor={`isUpdate-${index}`}>
                                        {values.version_data[index].isUpdate === "true" || values.version_data[index].isUpdate === true ? 'Yes' : 'No'}
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <label className="small text-muted font-weight-bold mb-1">File Upload</label>
                                    <ImageUploadField
                                      name="version_data"
                                      index={index}
                                      item={item}
                                      setFieldValue={setFieldValue}
                                      imageFile={versionImageFile}
                                      accept="*"
                                    />
                                  </div>

                                  <div className="col-md-2 text-right">
                                    <button
                                      className="btn btn-outline-danger btn-sm"
                                      type="button"
                                      onClick={() => arrayHelpers.remove(index)}
                                      disabled={values.version_data.length === 1}
                                    >
                                      <ClearIcon fontSize="small" /> Remove
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    />

                    <div className="d-flex mt-4">
                      <button
                        type="submit"
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: '130px',
                          height: '45px',
                          border: 'none',
                          backgroundColor: '#ffb400',
                          color: '#000',
                          borderRadius: '12px',
                          fontWeight: 'bold',
                          cursor: 'pointer'
                        }}
                        disabled={buttonLoader}
                      >
                        Submit
                        {buttonLoader && (
                          <div
                            className="spinner-border ml-2"
                            role="status"
                            style={{ height: "16px", width: "16px" }}
                          />
                        )}
                      </button>
                      <button
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ml-3"
                        style={{
                          width: '130px',
                          height: '45px',
                          borderRadius: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div className="card">
            <Box sx={{ borderBottom: 1, borderColor: "divider", px: 4, pt: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Tabs
                value={platformTab === "android" ? 0 : 1}
                onChange={(e, newValue) => {
                  const newPlatform = newValue === 0 ? "android" : "ios";
                  setPagination({ start: 0, end: showPrePage });
                  setPlatformTab(newPlatform);
                }}
                aria-label="platform tabs"
                sx={{
                  "& .MuiTabs-flexContainer": {
                    justifyContent: "flex-start !important",
                    gap: "16px",
                  },
                  "& .MuiTab-root": {
                    minWidth: "100px",
                    fontWeight: "bold",
                    textTransform: "none",
                    fontSize: "0.95rem",
                  },
                }}
              >
                <Tab label="Android" />
                <Tab label="iOS" />
              </Tabs>
              {accessObject?.editGameHandle === true && (
                <button
                  onClick={() => {
                    openAddTournament(1);
                  }}
                  type="button"
                  className="btn btn-primary mb-2"
                >
                  Create
                </button>
              )}
            </Box>


            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Game No</th>
                    <th>Bundle Name</th>
                    <th>Scene Name</th>
                    <th>Number Incruments</th>
                    <th>Tag</th>
                    <th>Category</th>
                    <th>Platform Type</th>
                    <th>Active Free</th>
                    <th>Active Cash</th>
                    {(accessObject?.editGameHandle === true ||
                      accessObject?.deleteGameHandle === true) && (
                        <th style={{ textAlign: "center" }}>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {!loader ? (
                    <>
                      {tableData.length > 0 ? (
                        <>
                          {tableData
                            ?.slice(pagination.start, pagination.end)
                            .map((item, index) => (
                              <>
                                <tr key={index}>
                                  <td>{index + 1 + pagination.start}</td>
                                  <td>
                                    {item.gameNo === 3 && "Block Blast"}
                                    {item.gameNo === 7 && "Candy Cream"}
                                    {item.gameNo === 9 && "Chess Gamebit"}
                                    {item.gameNo === 10 && "Ludo Lion"}
                                  </td>
                                  <td>{item.bundleName}</td>
                                  <td>{item.sceneName}</td>
                                  <td>{item.numberIncruments}</td>
                                  <td>{item.tag === 0 ? "New" : "Popular"}</td>
                                  <td>
                                    {item.category === 0
                                      ? "Causal"
                                      : "Other add"}
                                  </td>
                                  <td>
                                    {item.platformType == 0 && "Android"}
                                    {item.platformType == 1 && "iOS"}
                                    {item.platformType == 2 && "Web"}
                                  </td>
                                  <td>{item.activeFree ? "On" : "Off"}</td>
                                  <td>{item.activeCash ? "On" : "Off"}</td>
                                  {(accessObject?.editGameHandle === true ||
                                    accessObject?.deleteGameHandle ===
                                    true) && (
                                      <td className="justify-content-evenly ">
                                        <div className="d-flex">
                                          {accessObject?.editGameHandle ===
                                            true && (
                                              <EditIcon
                                                className="mr-3 courser"
                                                onClick={() =>
                                                  clickEditButton(item)
                                                }
                                              />
                                            )}
                                          {accessObject?.deleteGameHandle ===
                                            true && (
                                              <ClearIcon
                                                className="courser text-danger"
                                                onClick={() =>
                                                  warningWithConfirmMessage(item)
                                                }
                                              />
                                            )}
                                        </div>
                                      </td>
                                    )}
                                </tr>
                              </>
                            ))}
                        </>
                      ) : (
                        <>
                          <EmptyState colSpan={11} />
                        </>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </tbody>
              </table>
              <div className="mt-4">{loader && <Loader />}</div>
            </div>
            {tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
